export const PREFERRED_LANGUAGES = Object.freeze({
  'en-US': 'English',
  'ar-SA': 'Arabic',
  'bn-IN': 'Bengali',
  'zh-CN': 'Chinese - Simplified',
  'zh-TW': 'Chinese - Traditional',
  'fr-FR': 'French',
  'de-DE': 'German',
  'gu-IN': 'Gujarati',
  'ht-HT': 'Haitian Creole',
  'hi-IN': 'Hindi',
  'hmn-US': 'Hmong',
  'it-IT': 'Italian',
  'ja-JP': 'Japanese',
  'km-KH': 'Khmer - Cambodian',
  'ko-KR': 'Korean',
  'lo-LA': 'Laotian',
  'ne-NP': 'Nepali',
  'fa-IR': 'Persian',
  'pl-PL': 'Polish',
  'pt-PT': 'Portuguese',
  'pa-IN': 'Punjabi',
  'ru-RU': 'Russian',
  'so-SO': 'Somali',
  'es-ES': 'Spanish',
  'fil-PH': 'Tagalog - Filipino',
  'ur-PK': 'Urdu',
  'vi-VN': 'Vietnamese',
});

export const PREFERRED_LANGUAGES_DROPDOWN_OPTIONS = Object.freeze(
  Object.entries(PREFERRED_LANGUAGES).map(([key, value]) => ({
    value: key,
    label: value,
  })),
);

export const PREFERRED_LANGUAGES_DROPDOWN_OPTIONS_WITH_N_A = Object.freeze([
  ...Object.entries(PREFERRED_LANGUAGES).map(([key, value]) => ({
    value: key,
    label: value,
  })),
  {
    value: 'N/A',
    label: 'N/A',
  },
]);

export const DEFAULT_PREFERRED_LANGUAGE_CODE = 'en-US';
